import {
  getCdnImageSrc,
  Image,
  responsive,
  VStack,
  HStack,
  colors,
  VLine,
  customEvent,
} from "goi_common";

import { Box } from "@chakra-ui/react";
import { useEffect, useState, useRef } from "react";

// function TripStoreModal({ onClose }: { onClose: () => void }) {
//   const [name, setName] = useState("");
//   const [phone, setPhone] = useState("");
//   const [isMember, setIsMember] = useState<string>("");
//   useEffect(() => {
//     sessionStorage.setItem("tripStoreModalShown", "true");
//   }, []);

//   return (
//     <VStack padding="20px" alignItems="center">
//       <HStack justifyContent="flex-end" width="100%">
//         <Box onClick={onClose}>
//           <ColorIcon name="icon-x-mono" size={16} color={colors.gray500} />
//         </Box>
//       </HStack>
//       <Box className="subtitle_18_b" textAlign="center">
//         잠깐! 특가 해외여행
//         <br />
//         놓치고 가실 건가요?
//       </Box>
//       <Box
//         className="subtitle_16_b"
//         textAlign="center"
//         padding="12px 0px"
//         margin="10px 0px"
//         backgroundColor={colors.orange100}
//         color={colors.brown650}
//         width="100%"
//         borderRadius="8px"
//       >
//         현재 이벤트 알림 신청자 : 1,247명
//       </Box>
//       <Box
//         className="subtitle_16_m"
//         padding="18px 14px"
//         lineHeight="32px"
//         margin="10px 0px"
//         backgroundColor={colors.gray50}
//         color={colors.gray700}
//         width="100%"
//         borderRadius="8px"
//       >
//         ✅ 해외숙박권 무료제공 추첨권 제공
//         <br />
//         ✅ 특가 정보 우선 알림
//         <br />
//         ✅ 한정 혜택 독점 제공
//         <br />
//       </Box>

//       <VStack width="100%" gap="12px" margin="20px 0">
//         <VStack width="100%" alignItems="flex-start" gap="4px">
//           <Box className="subtitle_14_b" color={colors.gray700}>
//             이름
//           </Box>
//           <Input
//             value={name}
//             onChange={(e) => setName(e.target.value)}
//             placeholder="이름을 입력해주세요"
//             borderColor={colors.gray300}
//             _placeholder={{ color: colors.gray400 }}
//             size="md"
//           />
//         </VStack>

//         <VStack width="100%" alignItems="flex-start" gap="4px">
//           <Box className="subtitle_14_b" color={colors.gray700}>
//             휴대폰번호
//           </Box>
//           <Input
//             value={phone}
//             onChange={(e) => setPhone(parsingPhoneNumber(e.target.value))}
//             placeholder="010-1234-5678"
//             borderColor={colors.gray300}
//             _placeholder={{ color: colors.gray400 }}
//             size="md"
//           />
//         </VStack>

//         <VStack width="100%" alignItems="flex-start" gap="4px">
//           <Box className="subtitle_14_b" color={colors.gray700}>
//             100원상조 가입 유무
//           </Box>
//           <HStack width="100%" gap="10px">
//             <Box
//               width="50%"
//               height="40px"
//               border="2px solid"
//               borderRadius="8px"
//               className="subtitle_14_m"
//               borderColor={colors.gray200}
//               backgroundColor={isMember === "가입" ? colors.gray200 : colors.gray50}
//               position="relative"
//               cursor="pointer"
//               onClick={() => setIsMember("가입")}
//               display="flex"
//               alignItems="center"
//               justifyContent="center"
//               textAlign="center"
//             >
//               가입
//             </Box>
//             <Box
//               width="50%"
//               height="40px"
//               border="2px solid"
//               className="subtitle_14_m"
//               borderColor={colors.gray200}
//               borderRadius="8px"
//               backgroundColor={isMember === "미가입" ? colors.gray200 : colors.gray50}
//               position="relative"
//               cursor="pointer"
//               onClick={() => setIsMember("미가입")}
//               display="flex"
//               alignItems="center"
//               justifyContent="center"
//               textAlign="center"
//             >
//               미가입
//             </Box>
//           </HStack>
//         </VStack>
//       </VStack>
//       <Button
//         css={{
//           width: "100%",
//           height: "50px",
//           backgroundColor: colors.gray200,
//           color: "white",
//           borderRadius: "8px",
//           fontSize: "16px",
//           fontWeight: 600,
//           lineHeight: "24px",
//         }}
//         onClick={() => {
//           //           if (!name || !phone || !isMember) {
//           //             alert("모든 항목을 입력해주세요.");
//           //             return;
//           //           }
//           //           sendTripMessageToSlack(`
//           // *[해외여행 이벤트 신청]* <!subteam^S074QTGM8RF>
//           // 이름: ${name}
//           // 휴대폰 번호: ${phone}
//           // 100원상조 가입 유무: ${isMember}`).then(() => {
//           //             alert("신청이 완료되었습니다. 이벤트 페이지로 이동합니다.");
//           //             window.open(
//           //               "https://goi.tripstore.kr/promotion-list?airports=791,971&campaign=250609_promotion_goi&discounts=2&kinds=PACKAGE,AIRTEL&personnelAdult=2&personnelChild=0&personnelInfant=0&regionSub=%EA%B3%A0%EC%9D%B4%20X%20%ED%8A%B8%EB%A6%BD%EC%8A%A4%ED%86%A0%EC%96%B4&retrieveIds=9118&sort=recommended&title=%EA%B3%A0%EC%9D%B4%20X%20%ED%8A%B8%EB%A6%BD%EC%8A%A4%ED%86%A0%EC%96%B4&version=1",
//           //               "_blank"
//           //             );
//           //             onClose();
//           //           });
//         }}
//       >
//         🎁 알림 받고 혜택 확인하기
//       </Button>
//       <Button
//         css={{
//           marginTop: "12px",
//           width: "100%",
//           height: "50px",
//           backgroundColor: colors.gray50,
//           color: colors.gray700,
//           borderRadius: "8px",
//           fontSize: "16px",
//           fontWeight: 600,
//           lineHeight: "24px",
//         }}
//         onClick={() => {
//           // window.open(
//           //   "https://goi.tripstore.kr/promotion-list?airports=791,971&campaign=250609_promotion_goi&discounts=2&kinds=PACKAGE,AIRTEL&personnelAdult=2&personnelChild=0&personnelInfant=0&regionSub=%EA%B3%A0%EC%9D%B4%20X%20%ED%8A%B8%EB%A6%BD%EC%8A%A4%ED%86%A0%EC%96%B4&retrieveIds=9118&sort=recommended&title=%EA%B3%A0%EC%9D%B4%20X%20%ED%8A%B8%EB%A6%BD%EC%8A%A4%ED%86%A0%EC%96%B4&version=1",
//           //   "_blank"
//           // );
//         }}
//       >
//         알림 신청 안하고 페이지 보러가기
//       </Button>
//       <Box className="caption_12_m" color={colors.gray500} marginTop="12px">
//         *간단한 안내를 위해 유선 연락을 드릴 수도 있어요.
//       </Box>
//     </VStack>
//   );
// }

export default function TripStore() {
  // const router = useRouter();
  // const overlay = useOverlay();
  // const [hasShownModal, setHasShownModal] = useState(false);
  const vlineRef = useRef<HTMLDivElement>(null);

  // const openModal = useCallback(
  //   ({ isBtnClick }: { isBtnClick?: boolean }) => {
  //     if (hasShownModal && !isBtnClick) return;

  //     overlay.open(({ isOpen, close: onClose }) => (
  //       <OverlayModal
  //         onClose={onClose}
  //         isOpen={isOpen}
  //         modalContentStyle={{
  //           maxWidth: "360px",
  //           height: "760px",
  //           borderRadius: "20px",
  //         }}
  //         overlayModalContent={<TripStoreModal onClose={onClose} />}
  //       />
  //     ));
  //     setHasShownModal(true);
  //     sessionStorage.setItem("tripStoreModalShown", "true");
  //   },
  //   [overlay, hasShownModal]
  // );

  return (
    <VStack width="100%" height="100%" alignItems="center" padding="0 0 100px">
      <VStack
        css={responsive({
          maxWidth: "480px",
          width: "100%",
          minHeight: "calc(100dvh - 74px)",
          position: "relative",
        })}
      >
        <Image
          src={getCdnImageSrc(`direct/promotion/trip-store/1-trip-1.png`)}
          width="100%"
          height="auto"
          alt=""
        />
        <HStack
          css={{
            backgroundColor: colors.gray200,
            padding: "30px 20px",
            borderRadius: "8px",
            color: colors.gray700,
            textAlign: "center",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "18px",
            fontWeight: 600,
            lineHeight: "24px",
          }}
        >
          이벤트가 마감되었습니다.
        </HStack>

        <Image
          src={getCdnImageSrc(`direct/promotion/trip-store/1-trip-2.png`)}
          width="100%"
          height="auto"
          alt=""
        />
        <Image
          src={getCdnImageSrc(`direct/promotion/trip-store/1-trip-3.png`)}
          width="100%"
          height="auto"
          alt=""
        />
        <Image
          src={getCdnImageSrc(`direct/promotion/trip-store/1-trip-4.png`)}
          width="100%"
          height="auto"
          alt=""
        />

        <VLine width="100%" height="16px" color={colors.gray50} />

        <VStack padding="40px 20px" gap="16px">
          <Box className="subtitle_21_sb gray900">
            휴양지 가기 좋은 요즘 날씨
            <br />
            인기 패키지를 추천드려요 🏖️
          </Box>

          <TripCards
            region="short"
            margin="0"
            time={3000}
            title={"연차 부담없는 단거리여행\n가깝지만 색다르게 여행해요"}
            description={
              "비행기 타자마자 착륙?! 주말이면 충분해요!\n내일 떠나도 부담 없는 단거리 여행지"
            }
          />
          <TripCards
            region="esasia-g"
            time={3000}
            title={"동남아 관광지 여행\n신비롭고 매력적인 로컬 문화를 즐겨요"}
            description={
              "익숙한 듯 낯선, 동남아의 신비롭고 매력적인\n랜드마크들과 로컬 문화를 즐겨보세요"
            }
          />
          <Box ref={vlineRef}>
            <TripCards
              region="esasia-r"
              time={3000}
              title={"동남아 휴양지 여행\n파도 소리 들으며 여유롭게 힐링해요"}
              description={
                "눈부신 에메랄드 빛 바다와 화이트 샌드비치,\n완벽한 휴양이 필요할 때 떠나요"
              }
            />
          </Box>
          <TripCards
            region="er"
            time={3000}
            title={"감성 가득 유럽여행\n인생에 꼭 한 번은 가야해요"}
            description={
              "다양한 문화와 역사, 장대한 자연을 만나는\n인생에 한 번은 꼭 가봐야 하는 유럽여행"
            }
          />
        </VStack>
        <VLine width="100%" height="16px" color={colors.gray50} />
        <Image
          src={getCdnImageSrc(`direct/promotion/trip-store/1-trip-5.png`)}
          width="100%"
          height="auto"
          alt=""
        />
        <VStack alignItems="center" padding="10px 0 40px">
          <Box
            className="gray700"
            backgroundColor={colors.gray50}
            padding="12px 20px"
            borderRadius="8px"
            cursor="pointer"
            onClick={() => {
              customEvent({
                newGtm: { path: "promotion", trigger_and_target: "share" },
              });
              alert("주소가 복사되었습니다.");
              window.navigator.clipboard.writeText(window.location.href);
            }}
          >
            이벤트 공유하기
          </Box>
        </VStack>
        <Image
          src={getCdnImageSrc(`direct/promotion/trip-store/1-trip-6.png`)}
          width="100%"
          height="auto"
          alt=""
        />
      </VStack>
    </VStack>
  );
}

// function CouponTimer() {
//   const INTERVAL = 1000;
//   const [timeLeft, setTimeLeft] = useState<number>(0);

//   const { nowTime } = useAsiaSeoulTime();

//   // 다음 일요일 23:59:59 시간 계산
//   const getNextSundayEnd = () => {
//     const now = dayjs().tz("Asia/Seoul");

//     // 현재가 일요일인 경우
//     if (now.day() === 0) {
//       // 현재가 일요일 23:59:59 이후인 경우 다음 주 일요일로 설정
//       if (now.hour() === 23 && now.minute() === 59 && now.second() === 59) {
//         return now.add(7, "day").hour(23).minute(59).second(59).millisecond(999);
//       }
//       // 현재가 일요일 23:59:59 이전인 경우 현재 일요일로 설정
//       return now.hour(23).minute(59).second(59).millisecond(999);
//     }

//     // 현재가 일요일이 아닌 경우 다음 주 일요일로 설정
//     const daysUntilSunday = 7 - now.day();
//     return now.add(daysUntilSunday, "day").hour(23).minute(59).second(59).millisecond(999);
//   };

//   useEffect(() => {
//     const targetTime = getNextSundayEnd().valueOf();
//     const remainingTime = targetTime - nowTime;
//     setTimeLeft(remainingTime);
//   }, [nowTime]);

//   useInterval(() => {
//     setTimeLeft((prev) => prev - INTERVAL);
//   }, INTERVAL);

//   const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
//   const hour = String(Math.floor((timeLeft / (1000 * 60 * 60)) % 24)).padStart(2, "0");
//   const minute = String(Math.floor((timeLeft / (1000 * 60)) % 60)).padStart(2, "0");
//   const second = String(Math.floor((timeLeft / 1000) % 60)).padStart(2, "0");

//   return (
//     <VStack
//       justifyContent="space-between"
//       alignItems="center"
//       padding="12px 16px"
//       background={"#E5F4FF"}
//     >
//       <Box fontSize="14px" fontWeight={500} color={"#2699F7"}>
//         이번주 종료까지
//       </Box>
//       <HStack
//         gap={"6px"}
//         css={{
//           fontSize: "21px",
//           fontWeight: 600,
//           color: colors.gray900,
//         }}
//       >
//         <>
//           <span>{days}일</span>
//           <span>{hour}:</span>
//           <span>{minute}:</span>
//           <span>{second}</span>
//         </>
//       </HStack>
//     </VStack>
//   );
// }

function TripCards({
  region = "osaka",
  time = 3000,
  title = "인기 여행지 오사카에\n근교 도시까지",
  description = "오사카 여행에서 놓치기 아까운 근처 여행지들\n각기 다른 매력의 도시들로 떠나보세요",
  margin = "20px 0 0",
}: {
  region: string;
  time: number;
  title: string;
  description: string;
  margin?: string;
}) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const images = [
    `direct/promotion/trip-store/1-${region}-1.png`,
    `direct/promotion/trip-store/1-${region}-2.png`,
    `direct/promotion/trip-store/1-${region}-3.png`,
    `direct/promotion/trip-store/1-${region}-4.png`,
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, time);

    return () => clearInterval(timer);
  }, []);

  return (
    <VStack width="100%" position="relative" margin={margin || "20px 0 0"}>
      <Box width="100%" overflow="hidden" position="relative">
        <Box
          display="flex"
          transition="transform 0.5s ease-in-out"
          transform={`translateX(-${currentIndex * 100}%)`}
        >
          {images.map((src, index) => (
            <Box
              key={index}
              minWidth="100%"
              flexShrink={0}
              position="relative"
              css={{
                paddingTop: "87.5%",
              }}
            >
              <Image
                src={getCdnImageSrc(src)}
                width="100%"
                height="100%"
                alt=""
                css={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  objectFit: "cover",
                  padding: "0 2px",
                }}
              />
            </Box>
          ))}
        </Box>
        <Box
          css={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background:
              "linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0) 50%)",
            padding: "20px",
            boxSizing: "border-box",
            borderRadius: "13px",
            pointerEvents: "none",
          }}
        >
          <Box
            css={{
              color: "white",
              fontSize: "18px",
              fontWeight: 600,
              lineHeight: "1.4",
              whiteSpace: "pre-line",
            }}
          >
            {title}
          </Box>
        </Box>
      </Box>

      <HStack
        css={{
          position: "absolute",
          bottom: "64px",
          width: "100%",
          justifyContent: "center",
          gap: "10px",
        }}
      >
        {images.map((_, index) => (
          <Box
            key={index}
            width="8px"
            height="8px"
            borderRadius="50%"
            margin="0px 4px"
            backgroundColor={
              currentIndex === index ? colors.gray900 : colors.gray300
            }
            transition="background-color 0.3s"
          />
        ))}
      </HStack>
      <Box
        css={{
          marginTop: "32px",
          color: colors.gray700,
          fontSize: "16px",
          lineHeight: "1.5",
          whiteSpace: "pre-line",
        }}
      >
        {description}
      </Box>
    </VStack>
  );
}
